export default "__VITE_ASSET__HfWSC2Nz__"